import Vue from 'vue'

export default {
  LOAD_SUMMARY(state, payload) {
    for (const key of Object.keys(payload))
      Vue.set(state.summary, key, payload[key])
  },
  LOAD_META(state, payload) {
    for (const key of Object.keys(payload))
      Vue.set(state.meta, key, payload[key])
  },
  DRAFT_SAVE(state, { type, key, data }) {
    if (!state.drafts[type])
      Vue.set(state.drafts, type, {})
    Vue.set(state.drafts[type], key, data)
  },
  CLEAR_BILLS(state) {
    state.summary.bills = []
  },
  DRAFT_DELETE(state, { type, key }) {
    Vue.delete(state.drafts[type], key)
  },
  COMPUTE_CUSTOMER_CONTRACTS(state) {
    const pairs = {}
    for (const contract of state.summary.contracts) {
      if (contract._customers) {
        for (const customer of contract._customers) {
          if (!pairs[customer])
            pairs[customer] = []
          pairs[customer].push({
            contract: contract._id,
            room: contract._room,
          })
        }
      }
    }
    state.computed.customer_contracts = pairs

    for (const customer of state.summary.customers)
      customer.rooms = pairs[customer._id]
  },
  COMPONENTS_STATE_UPDATE(state, { name, obj }) {
    if (!state.components[name])
      state.components[name] = {}
    state.components[name] = Object.assign(state.components[name], obj)
  },
  UPDATE_PATH(state, { path = '', value }) {
    const names = path.split('.')
    if (names.length > 1) {
      const last_name = names[names.length - 1]
      let node = state
      for (const n of names.slice(names.length - 2, names.length))
        node = node[n] || (Number.isInteger(n) ? [] : {})
      node[last_name] = value
    }
  },
  UPDATE_TRACKING_NOTES(state, { room_id, notes }) {
    const room = state.summary.rooms.find(r => r._id === room_id)
    if (room)
      room.tracking_notes = notes
  },
  UPDATE_GENERAL_NOTES(state, notes = []) {
    state.summary.notes = notes
  },
}



// WEBPACK FOOTER //
// ./client/src/store/mutations.js